import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Dropdown, Loader, Popup, Icon} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {pageSizes} from '../../../../common/constants/lists';
import {partClassification} from '../../../../common/dictionaries/classification';
import {buildParameters} from '../../../../common/util/parametersUtils';
import TablePaginator from '../../../../common/components/tablePaginator';
import './cpdQueriesList.scss';

class CpdQueriesTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'partData': {},
    };
    this.onSearch = this.onSearch.bind(this);
    this.onViewPart = this.onViewPart.bind(this);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
    this.onGenerateClick = this.onGenerateClick.bind(this);
  }

  componentDidMount() {
    this.props.changePartsListPage(0);
    this.onSearch(0);
  }

  componentDidUpdate(prevProps) {
    const {disableGenerateDataSheet} = this.props;
    if (
      prevProps.disableGenerateDataSheet !== disableGenerateDataSheet &&
      !disableGenerateDataSheet
    ) {
      this.setState({'partData': {}});
    }
  }

  onSearch(value) {
    const {pageSize} = this.props;
    this.props.changePartsListPage(value);
    const parameters = buildParameters(this.props);
    this.props.fetchPartsList(parameters, pageSize, value);
  }

  onViewPart(code) {
    this.props.navigateTo(`/partes/consultas/ver/${code}`);
  }

  onPageSizeClick(data) {
    this.props.changePartsListPageSize(data.value);
    const parameters = buildParameters(this.props);
    this.props.fetchPartsList(parameters, data.value, 0);
  }

  onGenerateClick(element, event) {
    event.stopPropagation();
    const {generatePartDataSheet} = this.props;
    const partno = element.code.trim();
    this.setState({'partData': element});
    generatePartDataSheet(partno);
  }

  renderHeader() {
    return (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell textAlign='center'>Código</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Descripción</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>
            Ubicación Actual
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>
            Ubicación Anterior
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Clasificación</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Origen</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Acciones</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    );
  }

  renderLoaderOrParts() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderParts();
  }

  renderTechnicalFormButton(element) {
    const {disableGenerateDataSheet} = this.props;
    const {code} = this.state.partData;

    if (disableGenerateDataSheet && code.trim() === element.code.trim()) {
      return <Loader inline active size='mini' />;
    }
    return (
      <Popup
        trigger={
          <Icon
            name='file'
            color='blue'
            rotated='clockwise'
            size='large'
            onClick={(e) => this.onGenerateClick(element, e)}
            disabled={disableGenerateDataSheet}
          />
        }
        content='Generar ficha técnica'
        position='top center'
        inverted
      />
    );
  }

  renderParts() {
    const {parts} = this.props;

    if (!parts.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={13}>
            No hay datos disponibles con los filtros seleccionados
          </Table.Cell>
        </Table.Row>
      );
    }

    return parts.map((element, index) => {
      return (
        <Table.Row key={index} onClick={() => this.onViewPart(element.code)}>
          <Table.Cell textAlign='center'>{element.code}</Table.Cell>
          <Table.Cell textAlign='center'>{element.name}</Table.Cell>
          <Table.Cell textAlign='center'>{element.currentLocation}</Table.Cell>
          <Table.Cell textAlign='center'>{element.previousLocation}</Table.Cell>
          <Table.Cell textAlign='center'>
            {partClassification[element.classification] || 'Repuestos'}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.origin}</Table.Cell>
          <Table.Cell textAlign='center'>
            {this.renderTechnicalFormButton(element)}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderPagination() {
    const {pageNumber, pageSize, totalItems} = this.props;

    if (totalItems <= pageSize) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onSearch}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  render() {
    return (
      <Table striped className='toyota-grid'>
        {this.renderHeader()}
        <Table.Body>{this.renderLoaderOrParts()}</Table.Body>
        {this.renderPagination()}
      </Table>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.parts.loading,
    'parts': state.parts.page,
    'pageNumber': state.parts.pageNumber,
    'pageSize': state.parts.pageSize,
    'totalItems': state.parts.itemsCount,
    'disableGenerateDataSheet': state.parts.downloadingDataSheet,
    'dataSheetUrl': state.parts.dataSheetUrl,
  };
};

const {
  fetchPartsList,
  changePartsListPage,
  changePartsListPageSize,
  generatePartDataSheet,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  fetchPartsList,
  changePartsListPage,
  changePartsListPageSize,
  generatePartDataSheet,
  navigateTo,
})(CpdQueriesTable);
